import { Container, Typography } from "@mui/material";
import AuthContainer from "../../../components/Containers/AuthContainer.js";
import appcolors from "../../../constants/Colors.js";
import ResetPasswordForm from "./ResetPasswordform.js";
import { t } from "i18next";
import { Trans } from "react-i18next";

const ResetPassword = () => {
  return (
    <AuthContainer>
      <Container sx={{ maxWidth: "550px !important" }}>
        <Typography variant="auth_primary" component={"h1"}>
          {t("newPassword")}
        </Typography>
        <Typography variant="auth_secondary" component={"p"} sx={{ mt: 0.5 }}>
          <Trans
            i18nKey="welcomeResetMessage"
            style={{ color: appcolors.slateGrey }}
            color={appcolors.slateGrey}
          >
            Welcome to <b style={{ color: "black" }}>Service Provider</b> CRM,
            Please enter your new password
          </Trans>
        </Typography>
        <ResetPasswordForm />
      </Container>
    </AuthContainer>
  );
};

export default ResetPassword;
